module.exports = __webpack_public_path__ + "img/voix-du-nord.c6ac4f03.png";